import React, { Dispatch, FunctionComponent, MouseEventHandler } from 'react';
import { TransformWrapper } from 'react-zoom-pan-pinch';

import ImageZoomControls from './ImageZoomControls';

import { FeaturedImage } from 'types/product';

import css from 'styles/components/common/zoom/imageZoom.scss';

interface ZoomWrapperProps {
  scale: number;
  zoomIn: MouseEventHandler<HTMLButtonElement>;
  zoomOut: MouseEventHandler<HTMLButtonElement>;
  positionX: number;
  positionY: number;
  setPositionX: Dispatch<React.SetStateAction<number>>;
  setPositionY: Dispatch<React.SetStateAction<number>>;
  resetTransform: () => void;
}

export interface ImageZoomProps {
  image: FeaturedImage;
  showInstructions: boolean;
  setShowInstructions: Dispatch<React.SetStateAction<boolean>>;
}
/**
 * PDP Assets gallery asset zoom
 * @see https://github.com/prc5/react-zoom-pan-pinch
 * @returns {FunctionComponent}
 */
export const ImageZoom: FunctionComponent<ImageZoomProps> = ({ image, showInstructions, setShowInstructions }) => {
  // Zoom framework config objects
  const BASE_CONTROLS = {
    minScale: 1,
    maxScale: 8,
    wrapperClass: css.zoom,
    contentClass: css.zoomContent,
    limitToBounds: false // pan indefinitely
  };
  const ZOOM_CONTROLS = {
    step: 12
  };
  const DISABLE_CONTROLS = {
    disabled: true
  };

  return (
    <TransformWrapper pinch={ZOOM_CONTROLS} zoomIn={ZOOM_CONTROLS} zoomOut={ZOOM_CONTROLS} wheel={DISABLE_CONTROLS} options={BASE_CONTROLS}>
      {({ scale, zoomIn, zoomOut, positionX, positionY, setPositionX, setPositionY, resetTransform }: ZoomWrapperProps) => (
        <ImageZoomControls
          image={image}
          showInstructions={showInstructions}
          setShowInstructions={setShowInstructions}
          zoomIn={zoomIn}
          zoomOut={zoomOut}
          positionX={positionX}
          positionY={positionY}
          setPositionX={setPositionX}
          setPositionY={setPositionY}
          scale={scale}
          minScale={BASE_CONTROLS.minScale}
          maxScale={BASE_CONTROLS.maxScale}
          resetTransform={resetTransform}
        />
      )}
    </TransformWrapper>
  );
};

export default ImageZoom;
